export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'THEME_SYSTEM',
  LS_NAME: 'APP_THEME',
};

export const MY_SKILLS = [
  {
    sliderLabel: 'FRONT END',
    skills: [
      'JavaScript',
      'TypeScript',
      'HTML 5',
      'React',
      'React Router',
      'Context API',
    ],
  },
  {
    sliderLabel: 'DESIGN & TOOLS',
    skills: [
      'CSS 3',
      'Sass',
      'Bootstrap',
      'Ant Design',
      'Mantine UI',
      'Font Awesome',
      'Figma',
    ],
  },
  {
    sliderLabel: 'JS FRAMEWORKS / LIBRARIES',
    skills: ['Redux', 'React Query', 'HighCharts', 'Lodash', 'Moment.js'],
  },
  {
    sliderLabel: 'BACK-END',
    skills: ['Node.js', 'Express.js', 'Mongo DB', 'ORM', 'JWT'],
  },
  {
    sliderLabel: 'CONCEPTS / PRINCIPLES',
    skills: ['Algorithm Design', 'Data Structures', 'SOLID Principles', 'OOP'],
  },
  {
    sliderLabel: 'TECHNOLOGIES / TOOLS',
    skills: [
      'Git',
      'GitHub',
      'BitBucket',
      'Jira',
      'Postman',
      'Rest API',
      'Webpack',
      'Vite',
    ],
  },
  {
    sliderLabel: 'SOFT SKILLS',
    skills: [
      'Problem Solving',
      'Adaptability',
      'Collaboration',
      'Communication',
      'Creativity',
      'Research',
      'Self Study',
    ],
  },
];

export const PROJECT_COLUMN_COUNTS = {
  xs: 2,
  s: 2,
  m: 2,
  l: 3,
  xl: 3,
  '2xl': 3,
  '3xl': 4,
  '4xl': 4,
  '5xl': 4,
  '6xl': 4,
};
